import { Col, DateRangePickerField } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const LastImplementedFiscalYearPeriodColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectSearchFormType>();
  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });
  const skipAdministrativeReformTeamEvaluation = useWatch({
    control,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  if (sheetType !== 'RS' || skipAdministrativeReformTeamEvaluation === 'true') {
    return null;
  }

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <DateRangePickerField
        name="lastImplementedFiscalYearPeriod"
        label={t('projects.last-implemented-fiscal-year')}
        control={control}
        errors={errors}
        picker="year"
        allowEmpty={[true, true]}
        fieldStyle={{ width: '100%' }}
      />
    </Col>
  );
});
